import { InjectionToken } from '@angular/core';

export const dxMissingTranslationSink = new InjectionToken<(key: string) => void>('DX_MISSING_TRANSLATION_SINK');
